
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[businessSlug]",
      function () {
        return require("private-next-pages/[businessSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[businessSlug]"])
      });
    }
  